import {
  Button,
  Card,
  Col,
  Descriptions,
  Form,
  Input,
  Popconfirm,
  Row,
  Space,
  Table,
  Tag,
  message,
} from "antd";
import { getMerchantInfo } from "api/MerchantApi";
import {
  deleteSettlementTransaction,
  getSettlementPayments,
  getSettlementTransaction,
  searchSettlementData,
  updateSettlementAdjustment,
} from "api/SettlementApi";
import ETag from "components/ETag";
import { ISO8601 } from "components/Jarvis";
import { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
const { TextArea } = Input;

export default function SettlementDetail() {
  const [form] = Form.useForm();
  const { settlementID } = useParams();
  const [merchantData, setMerchantData] = useState({});
  const [settlementData, setSettlementData] = useState({});
  const [settlementTransaction, setSettlementTransaction] = useState([]);
  const refSettlementReceipt = useRef();
  const { mutate: getSettlement } = useMutation(
    "searchSettlement",
    (query) => searchSettlementData(query),
    {
      onSuccess: (res) => {
        if (res.code == 200) {
          setSettlementData(res.payload.data[0]);
        } else {
          message.info("Please contact us");
        }
      },
      onError: (error) => {
        // Error actions
        console.log("error", error);
      },
    }
  );
  const {} = useQuery("MerchantInfo", () => getMerchantInfo(settlementID), {
    onSuccess: (res) => {
      if (res.code == 200) {
        setMerchantData(res.payload);
      } else {
        message.info("Please contact us");
      }
    },
    onError: (error) => {
      // Error actions
      console.log("error", error);
    },
  });
  const {} = useQuery(
    "getSettlementTransactions",
    () => getSettlementTransaction(settlementID),
    {
      onSuccess: (res) => {
        if (res.code != 200) {
          console.log(res);
          message.info("Please contact us");
        } else {
          res.payload.forEach((element) => {
            getPayment(element);
          });
        }
      },
    }
  );

  const { mutate: getPayment, isFetching } = useMutation(
    (data) => getSettlementPayments(data.payment_id),
    {
      onSuccess: (res, data) => {
        if (res.code == 200) {
          const addValue = { ...data, types: res.payload.types };
          setSettlementTransaction((prevTransactions) => [
            ...prevTransactions,
            addValue,
          ]);
        }
      },
    }
  );
  const { mutate: deleteSettlementTransactionID } = useMutation(
    (id) => deleteSettlementTransaction(id),
    {
      onSuccess: (res, data) => {
        if (res.code == 200) {
          message.info("Deleted Transaction");
        }
      },
    }
  );
  const { mutate: updateAdjustment, isLoading: isAdjustmentFetching } =
    useMutation((data) => updateSettlementAdjustment(data), {
      onSuccess: (res, data) => {
        if (res.code == 200) {
          message.info("Settlement Adjustment Updated!");
          form.resetFields();
        }
      },
    });

  useEffect(() => {
    getSettlement(`?id=${settlementID}`);
  }, []);

  const receiptOnClick = () => {
    refSettlementReceipt.current.show();
  };

  const handleDelete = (id) => {
    deleteSettlementTransactionID({ uuid: id });
  };
  const columns = [
    { title: "PA Ref", dataIndex: "order_reference", key: "order_reference" },
    { title: "Merchant Ref", dataIndex: "order_reference" },
    { title: "Provider Ref", dataIndex: "order_reference" },
    {
      title: "Provider",
      dataIndex: "types",
      key: "types",
      render: (item) => {
        const tags = item.map((element) => (
          <Tag key={element}>{element.toUpperCase()}</Tag>
        ));
        return <>{tags}</>;
      },
    },
    {
      title: "Currency",
      dataIndex: "subtotal_currency",
      key: "subtotal_currency",
    },
    {
      title: "Amount",
      align: "right",
      dataIndex: "order_amount",
      key: "order_amount",
      render: (item) => parseFloat(item).toFixed(2),
    },
    {
      title: "Charge",
      align: "right",
      dataIndex: "fee_amount",
      key: "fee_amount",
      render: (item) => parseFloat(item).toFixed(2),
    },
    {
      title: "Net",
      align: "right",
      dataIndex: "subtotal_amount",
      key: "subtotal_amount",
      render: (item) => parseFloat(item).toFixed(2),
    },
    { title: "Status", dataIndex: "status", key: "status" },
    {
      title: "Created Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (item) => ISO8601(item),
    },
    {
      title: "Completed Time",
      dataIndex: "completed_at",
      key: "completed_at",
      render: (item) => ISO8601(item),
    },
    {
      title: "Action",
      key: "status",
      width: 100,
      render: (record) => (
        <Space size="middle">
          {/* delete */}
          <Popconfirm
            title="Delete Transaction"
            description="Are you sure to Delete Transaction in this Settlement?"
            onConfirm={(e) => handleDelete(record.uuid)}
            okText="Yes"
            cancelText="No"
          >
            <a>Delete</a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const adjustmentOnFinish = () => {
    form.validateFields().then((values) => {
      updateAdjustment({ ...values, settlementID });
    });
  };
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col>
          <Card title="Settlement Information">
            <Descriptions>
              {/* <Descriptions.Item label="MID">{settlementData?.merchant_id}</Descriptions.Item> */}
              <Descriptions.Item label="Company Name">
                {settlementData?.display_name}
              </Descriptions.Item>
              <Descriptions.Item label="Settlement Date">
                {ISO8601(settlementData?.created_at)}
              </Descriptions.Item>
              <Descriptions.Item label="Settlement Period">
                {settlementData?.period}
              </Descriptions.Item>
              <Descriptions.Item label="Currency">
                {settlementData?.currency}
              </Descriptions.Item>
              {settlementData.status && (
                <Descriptions.Item label="Status">
                  <ETag>{settlementData?.status}</ETag>
                </Descriptions.Item>
              )}
              <Descriptions.Item />
              <Descriptions.Item label="Bank Name">
                {merchantData?.bank_account_name}
              </Descriptions.Item>
              <Descriptions.Item label="Bank Account">
                {merchantData?.bank_account_number}
              </Descriptions.Item>
              <Descriptions.Item />
              <Descriptions.Item label="Net Amount">
                {settlementData?.net_amount}
              </Descriptions.Item>
              <Descriptions.Item label="Fee Amount">
                {settlementData?.fee_amount}
              </Descriptions.Item>
              <Descriptions.Item label="Settle Amount">
                {settlementData?.settle_amount}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card title="Adjustment">
            <Form
              width="100%"
              layout="vertical"
              form={form}
              onFinish={adjustmentOnFinish}
            >
              <Form.Item
                label="Adjustment (+ / -)"
                name="adjustment"
                rules={[
                  {
                    required: true,
                    message:
                      "Please input adjustment and the length should less than 18!",
                    max: 18,
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                label="Remark"
                type="textarea"
                name="remark"
                rules={[
                  {
                    required: true,
                    message:
                      "Please input remarkand the length should less than 65535!",
                    max: 65535,
                  },
                ]}
              >
                <TextArea rows={4} />
              </Form.Item>
              <Form.Item style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isAdjustmentFetching}
                >
                  Update
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col>
          <Table
            rowKey={"uuid"}
            loading={isFetching}
            columns={columns}
            dataSource={settlementTransaction}
          />
        </Col>
      </Row>
    </>
  );
}
